// tab actions
export const CHANGE_ENTITY_STACK_TAB = 'CHANGE_ENTITY_STACK_TAB'
export const TOGGLE_ENTITY_STACK = 'TOGGLE_ENTITY_STACK'
export const OPEN_ENTITY_STACK = 'OPEN_ENTITY_STACK'
export const WS_CHANGE_ENTITY_STACK_TAB = 'WS_CHANGE_ENTITY_STACK_TAB'
export const ENTITY_STACK_ADD_NOTIFICATION = 'ENTITY_STACK_ADD_NOTIFICATION'
export const ENTITY_STACK_REMOVE_NOTIFICATION = 'ENTITY_STACK_REMOVE_NOTIFICATION'

// app state actions
export const LOAD_APP_STATE_DEFERRED = 'LOAD_APP_STATE_DEFERRED'

// favourites state actions
export const LOAD_FAVOURITES_DEFERRED = 'LOAD_FAVOURITES_DEFERRED'
export const LOAD_FAVOURITES_DEFERRED_SUCCESS = 'LOAD_FAVOURITES_DEFERRED_SUCCESS'
export const LOAD_FAVOURITES_DEFERRED_LOCAL = 'LOAD_FAVOURITES_DEFERRED_LOCAL'
export const FAVOURITES_INVALIDATE = 'FAVOURITES_INVALIDATE'
